
import React from 'react'

import '../design/styles/footer.css'

const Footer = (props) => {

  return (
    <div className="footer">
      <p className='text-align-center'>© 2026 - Todos los derechos reservados</p>
    </div>
  )
}

export default Footer